import { RichiedenteList } from './../types/index';
import axios from 'axios';
import { Richiedente, IdVersion, RichiedenteCreateCommand, RichiedenteUpdateCommand } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/richiedenti';

export const getByKey = async (id: number): Promise<Richiedente> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};

export const getList = async (): Promise<RichiedenteList[]> => {
    return (await axios.get(`${baseUrl}`)).data;
};

export const create = async (command: RichiedenteCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: RichiedenteUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};

